module.exports = __webpack_public_path__ + "static/media/logo1024x1024.f3a9a8f1.png";